module.exports = __webpack_public_path__ + "static/media/card_index.fa3df154.png";